import React, { forwardRef } from 'react';

import styles from './DropdownItem.module.scss';
import clsx from 'clsx';

type DropdownItemProps = React.ComponentProps<'button'>;

export const DropdownItem = forwardRef<HTMLButtonElement, DropdownItemProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button ref={ref} className={clsx(styles.dropdownItem, className)} type="button" {...props}>
        <div className={styles.name}>{children}</div>
      </button>
    );
  }
);
